import Provider from './Provider';

export default Provider;
